import { SENSORS_MAP } from '@linearb/linjs-common';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { sensorsWithRateLimitSelector } from 'state/selectors/sensors-authorizations';
import { LBButton } from '@linearb/buzz';
import * as LighthouseService from 'common/services/lighthouse.service';
import { ARTICLE_IDS } from 'common/constants/constants';
import SensorDescription from './SensorDescription';

const SUPPORTED_RATE_LIMIT_NOTIFICATIONS = [
  { sensorId: SENSORS_MAP.JIRA, isSelfHosted: true }
];

const getSensorRateLimitDescription = sensor => {
  const mapSensorIdToDescription = {
    [SENSORS_MAP.JIRA]:
      'Your JIRA integration has reached its rate limit, which may affect data consistency and accuracy. You might need to adjust your server’s rate limit settings. '
  };
  const defaultDescription = `${sensor.name} integration has reached its rate limit`;
  const description =
    mapSensorIdToDescription[sensor?.sensor_id] || defaultDescription;

  return description;
};

const getSensorRateLimitCTA = sensor => {
  const isSelfHosted = sensor?.is_self_hosted;

  const mapSensorIdToCTA = {
    [SENSORS_MAP.JIRA]: isSelfHosted ? (
      <LBButton
        variant='outline'
        onClick={() =>
          LighthouseService.navigateArticle(ARTICLE_IDS.CONNECT_JIRA_SERVER)
        }
      >
        Learn More
      </LBButton>
    ) : null
  };
  const defaultCTA = null;

  const cta = mapSensorIdToCTA[sensor?.sensor_id] || defaultCTA;
  return cta;
};

const useRateLimitSensorsAuthorizations = () => {
  const rateLimitSensors = useSelector(sensorsWithRateLimitSelector);
  const supportedRateLimitSensors = useMemo(() => {
    const filterSupportedRateLimitSensor = sensor => {
      const sensorId = sensor?.sensor_id;
      const isSelfHosted = sensor?.is_self_hosted;

      for (const supportedSensor of SUPPORTED_RATE_LIMIT_NOTIFICATIONS) {
        if (
          supportedSensor.sensorId === sensorId &&
          supportedSensor.isSelfHosted === isSelfHosted
        ) {
          return true;
        }
      }
      return false;
    };

    return rateLimitSensors.filter(filterSupportedRateLimitSensor);
  }, [rateLimitSensors]);

  const rateLimitSensorsWithNotification = supportedRateLimitSensors.map(
    rateLimitSensor => {
      return {
        ...rateLimitSensor,
        notification: {
          title: <SensorDescription sensorAuthorization={rateLimitSensor} />,
          description: getSensorRateLimitDescription(rateLimitSensor),
          cta: getSensorRateLimitCTA(rateLimitSensor)
        }
      };
    }
  );

  return rateLimitSensorsWithNotification;
};

export default useRateLimitSensorsAuthorizations;
